module.exports = __webpack_public_path__ + "media/images/icons/filled/fund-23129c600a4ba5dcbe34e35b059a5e89.svg";